import http from '../../../utils/fetch';
import updownfile from '../../../utils/updownfile';
export default {

    baseUrl:"/api/swyl/v1/cost/bscSpecialOffer",

    getAmountByStr(q){ //TimeType
        return http({
            url: this.baseUrl + '/getAmountByStr', //TimeType
            method: 'post',
            params: q
        });
    },
    getAmountByCompany(q){ //TimeType
        return http({
            url:  '/api/swyl/v1/demo/bscCompanyPrice/getAmountByCompany', //TimeType
            method: 'post',
            params: q
        });
    }

}